import TemplateView from '../../TemplateView'

export default class ComponentsWrapper extends TemplateView {
    constructor({
        components = [],
        extraClass = '',
    }) {
        super()

        this.extraClass = extraClass
        this.components = components
    }

    templateHtml() {
        return '<div class="componentsWrapper <%=extraClass%>"></div>'
    }

    afterRender() {
        this.components.forEach(component => component.init(this.$el))
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/ComponentsWrapper.js